@if (visibleWidgets().length) {
  <div
    class="mb-mobileGap tablet:mb-tabletGap desktop:mb-desktopGap"
    [ngClass]="{
      'tablet:grid tablet:grid-cols-2 tablet:gap-3': visibleWidgets().length === 2,
    }"
  >
    @for (banner of visibleWidgets(); track $index) {
      <sc-mini-banner-widget [data]="banner"></sc-mini-banner-widget>
    }
  </div>
}
